import { Route, Routes, useLocation, useNavigationType } from "react-router-dom";
import { AnimatePresence, motion } from "motion/react";
import { useBackButton } from "../telegram/useBackButton";
import { slideVariants } from "../motion";
import Home from "./Home";
import Browse from "./Browse";
import BrowseType from "./BrowseType";
import Detail from "./Detail";
import ArtworkForm from "./ArtworkForm";

/**
 * Routes are imported, not lazy-loaded.
 *
 * Splitting them saved about 13 kB gzipped — every screen is small and the
 * query layer they all share is loaded up front regardless — and it cost a
 * Suspense fallback on the way into a record: the list unmounted, three grey
 * bars painted for a third of a second, and the thumbnail that is supposed to
 * grow into the hero had nothing to grow into, because the hero had not
 * mounted yet. The transition is the more valuable of the two.
 */
export function AppRoutes() {
  const location = useLocation();
  const navigationType = useNavigationType();
  useBackButton();

  // POP is the back button (Telegram's or the browser's): play the transition
  // in reverse so going back never feels like going somewhere new.
  const direction: 1 | -1 = navigationType === "POP" ? -1 : 1;
  const variants = slideVariants(direction);

  return (
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.div
        key={location.pathname}
        variants={variants}
        initial="hidden"
        animate="show"
        exit="exit"
        style={{ position: "absolute", inset: 0 }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/browse/:typeId" element={<BrowseType />} />
          <Route path="/artwork/:id" element={<Detail />} />
          <Route path="/artwork/:id/edit" element={<ArtworkForm />} />
          <Route path="/new" element={<ArtworkForm />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}
